import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('ayo_token'));
  const [loading, setLoading] = useState(true);

  const axiosAuth = useCallback(() => {
    return axios.create({
      baseURL: API,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/auth/me2`, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          setUser(res.data);
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('ayo_token');
          setToken(null);
          setUser(null);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setToken(res.data.token);
    setUser(res.data.user);
    localStorage.setItem('ayo_token', res.data.token);
    return res.data;
  };

  const register = async (name, email, password, roles) => {
    const res = await axios.post(`${API}/auth/register`, { name, email, password, roles });
    setToken(res.data.token);
    setUser(res.data.user);
    localStorage.setItem('ayo_token', res.data.token);
    return res.data;
  };

  const updateRoles = async (roles) => {
    const res = await axios.put(`${API}/auth/roles`, { roles }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setToken(res.data.token);
    setUser(res.data.user);
    localStorage.setItem('ayo_token', res.data.token);
    return res.data;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('ayo_token');
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, updateRoles, axiosAuth, API }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
